import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import McpKeyService from "../../services/McpKeyService";
import { getErrorAsList } from "../utils";

const initialState = {
  loading: false,
  error: undefined,
  keys: [],
  newKey: undefined,
};

export const clearErrorMcpKey = createAction("mcpKeys/clearErrorMcpKey");

export const clearNewMcpKey = createAction("mcpKeys/clearNewMcpKey");

export const getMyMcpKeys = createAsyncThunk("mcpKeys/getMyMcpKeys", async (args, thunkAPI) => {
  try {
    return await McpKeyService.list();
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const createMcpKey = createAsyncThunk("mcpKeys/createMcpKey", async (args, thunkAPI) => {
  try {
    return await McpKeyService.create({ name: args.name });
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const revokeMcpKey = createAsyncThunk("mcpKeys/revokeMcpKey", async (args, thunkAPI) => {
  try {
    return await McpKeyService.revoke({ id: args.id });
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue(getErrorAsList(error));
  }
});

export const mcpKeySlice = createSlice({
  name: "mcpKey",
  initialState,
  extraReducers: {
    // Clear error (if any)
    [clearErrorMcpKey]: (state) => {
      state.error = undefined;
    },

    // Dismiss the one-time reveal
    [clearNewMcpKey]: (state) => {
      state.newKey = undefined;
    },

    // List
    [getMyMcpKeys.pending]: (state) => {
      state.loading = true;
    },
    [getMyMcpKeys.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.keys = action.payload;
    },
    [getMyMcpKeys.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create
    [createMcpKey.pending]: (state) => {
      state.loading = true;
    },
    [createMcpKey.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      // The full token is present only here, once.
      state.newKey = action.payload;
      const { token, ...listItem } = action.payload;
      state.keys = [listItem, ...state.keys];
    },
    [createMcpKey.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Revoke
    [revokeMcpKey.pending]: (state) => {
      state.loading = true;
    },
    [revokeMcpKey.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.keys = state.keys.filter((key) => key.id !== action.payload);
    },
    [revokeMcpKey.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default mcpKeySlice.reducer;
